import { render, staticRenderFns } from "./mailConfigModal.vue?vue&type=template&id=c8eaf22a&scoped=true"
import script from "./mailConfigModal.vue?vue&type=script&lang=js"
export * from "./mailConfigModal.vue?vue&type=script&lang=js"
import style0 from "./mailConfigModal.vue?vue&type=style&index=0&id=c8eaf22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8eaf22a",
  null
  
)

export default component.exports